export const ACTION_GET_TOTAL_BOOKED_TIMESLOT = '/booking-portal/Appointment/GetTotalBookedDateAndTimeSlot';